/**
 * Encoding conversion table for JIS X 0212:1990 (Hojo-Kanji) to UTF-8
 */
var JISX0212_TO_UTF8_TABLE = null;
module.exports = JISX0212_TO_UTF8_TABLE;



//////////////////
// WEBPACK FOOTER
// ./node_modules/encoding-japanese/src/jisx0212-to-utf8-table.js
// module id = h3yv
// module chunks = 0 1